/**
 * Shared card primitives for the Settings page — used by the theme and
 * layout-direction pickers. Extracted to keep Settings.jsx focused on
 * orchestration.
 */

export function ThemeCard({ active, onClick, testid, icon, label, hint, swatches }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      aria-pressed={active}
      className="text-left p-4 rounded-xl border transition-all"
      style={{
        borderColor: active ? "var(--accent-primary)" : "var(--border-default)",
        background: active ? "var(--bg-accent)" : "var(--bg-card)",
        boxShadow: active ? "0 0 0 3px rgba(224,158,80,0.18)" : "none",
      }}
    >
      <div className="flex items-center gap-2 mb-2">
        <div
          className="h-7 w-7 rounded-md flex items-center justify-center"
          style={{
            background: active ? "var(--accent-primary)" : "var(--bg-accent)",
            color: active ? "#fff" : "var(--text-primary)",
          }}
        >
          {icon}
        </div>
        <div className="flex-1">
          <div className="text-sm font-medium text-[var(--text-primary)] leading-tight">{label}</div>
          <div className="text-[11px] text-[var(--text-muted)] leading-tight">{hint}</div>
        </div>
      </div>
      <div className="flex items-center gap-1.5 mt-3">
        {swatches.map((c) => (
          <span
            key={c}
            className="inline-block h-4 w-4 rounded-full border border-[var(--border-default)]"
            style={{ background: c }}
            aria-hidden="true"
          />
        ))}
      </div>
    </button>
  );
}

export function DirectionCard({ active, onClick, testid, icon, label, hint }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      aria-pressed={active}
      className="text-left p-3 rounded-xl border transition-all"
      style={{
        borderColor: active ? "var(--accent-primary)" : "var(--border-default)",
        background: active ? "var(--bg-accent)" : "var(--bg-card)",
        boxShadow: active ? "0 0 0 3px rgba(224,158,80,0.18)" : "none",
      }}
    >
      <div className="flex items-center gap-2 mb-1">
        <div
          className="h-6 w-6 rounded-md flex items-center justify-center flex-shrink-0"
          style={{
            background: active ? "var(--accent-primary)" : "var(--bg-accent)",
            color: active ? "#fff" : "var(--text-primary)",
          }}
        >
          {icon}
        </div>
        <div className="text-sm font-medium text-[var(--text-primary)] leading-tight">{label}</div>
      </div>
      <div className="text-[11px] text-[var(--text-muted)] leading-tight">{hint}</div>
    </button>
  );
}
